import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import routes from "routes.js";

const Sidebar = ({ open, onClose }) => {
  return (
    <div
      className={`fixed top-0 left-0 h-full w-64 sm:w-72 flex flex-col bg-gradient-to-b from-blue-50 via-blue-100 to-blue-200 shadow-2xl transition-transform duration-300 z-50 ${
        open ? "translate-x-0" : "-translate-x-[100%]"
      }`}
    >
      {/* Close Button for Mobile */}
      <span
        className="absolute top-3 right-3 sm:top-4 sm:right-4 block cursor-pointer xl:hidden text-blue-700 hover:text-blue-900 transition p-1"
        onClick={onClose}
        aria-label="Close menu"
      >
        <HiX className="h-5 w-5 sm:h-6 sm:w-6" />
      </span>

      {/* Logo + Brand - compact on small screens */}
      <div className="mt-6 sm:mt-8 flex flex-col items-center px-3 sm:px-4 pt-2">
        <img
          src="/logo.png"
          alt="Cloud Ironing logo"
          className="mb-1.5 sm:mb-2 h-12 w-12 sm:h-16 sm:w-16 xl:h-20 xl:w-20 object-contain"
        />
        <h1 className="text-base sm:text-xl xl:text-2xl font-bold uppercase text-blue-900 leading-tight text-center">
          Cloud Ironing
        </h1>
        <span className="mt-0.5 sm:mt-1 text-xs sm:text-sm font-medium text-blue-700">Admin Portal</span>
      </div>

      {/* Divider */}
      <div className="my-4 sm:my-6 xl:my-8 h-px bg-blue-300" />

      {/* Navigation Links - tighter on small screens, custom thin scrollbar */}
      <ul className="sidebar-scroll flex flex-col gap-1 sm:gap-2 px-2 sm:px-4 pb-4 overflow-y-auto flex-1 min-h-0">
        <Links
          routes={routes}
          itemClassName={({ isActive }) =>
            `flex items-center gap-3 px-4 py-3 rounded-lg font-medium transition-all duration-300 ${
              isActive
                ? "bg-blue-600 text-white shadow-md"
                : "text-blue-800 hover:bg-blue-200 hover:text-blue-900"
            }`
          }
          iconClassName="h-6 w-6"
        />
      </ul>
    </div>
  );
};

export default Sidebar;